import _tmpl from "./listingDetailWrapper.html";
import { LightningElement, registerComponent as _registerComponent } from 'lwc';

/**
 * Thin wrapper around the listing-detail page. Since `FF_TRYBUY_LISTING_DETAIL_V2`
 * was retired (W-24557579), its template renders only `<pages-listing-detail-v2>`
 * and this class carries no logic beyond the static padding hint. It is kept
 * deliberately rather than collapsed away:
 *
 * 1. **Stable DOM for Kaiju.** Removing the wrapper tag/host would change the
 *    rendered element tree the routed listing-detail view mounts into, which
 *    Kaiju visual-regression tests pin against. Preserving it keeps the DOM
 *    shape unchanged so those tests don't break.
 * 2. **Scaffolding for a future v3 redesign.** Keeping the wrapper as the single
 *    routing entry point (`Routes.LISTING` / `Routes.CONSULTANT_LISTING`) leaves
 *    the seam in place to reintroduce an old-vs-new fork — as was done for the
 *    v1→v2 migration — without re-plumbing routing.
 */
class ListingDetailWrapper extends LightningElement {
  static get pageContainerBottomPadding() {
    return 'none';
  }
  /*LWC compiler v7.1.3*/
}
const __lwc_component_class_internal = _registerComponent(ListingDetailWrapper, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;